import { inject, Injectable } from '@angular/core';
import { MessagesListResponse, MessagesParams } from '../models/messages.model';
import { map, Observable, tap } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@env/environment';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class MessagesService {
  private toaster = inject(ToastrService);
  private router = inject(Router);
  private http = inject(HttpClient);
  userBody: any = localStorage.getItem('shuwier_current_user') || null;
  user: { name: string; email: string; id: string } = this.userBody
    ? JSON.parse(this.userBody).user
    : { name: '', email: '', id: '' };
  getMessages(params: MessagesParams): Observable<MessagesListResponse> {
    const httpParams = new HttpParams().set('page', params.page).set('per_page', params.per_page);

    return this.http
      .get<MessagesListResponse>(`${environment.chat}/rooms`, {
        params: httpParams,
      })
      .pipe(
        tap((res) => {
          console.log('Before map:', res);
        }),
        map((res: MessagesListResponse) => ({
          ...res,
          data: res.data.map((message: any) => ({
            ...message,
            members: message.members.filter((member: any) => member.userId !== this.user?.id),
          })),
        })),
        tap((res) => {
          console.log('After map:', res);
        })
      );
  }

  getActiveMessages(): Observable<MessagesListResponse> {
    return this.http.get<MessagesListResponse>(`${environment.chat}/rooms/have-messages`).pipe(
      tap((res) => {
        console.log('Before map:', res);
      }),
      map((res: MessagesListResponse) => ({
        ...res,
        data: res.data.map((message: any) => ({
          ...message,
          members: message.members.filter((member: any) => member.userId !== this.user?.id),
        })),
      })),
      tap((res) => {
        console.log('After map:', res);
      })
    );
  }

  createRoom(payload: any) {
    return this.http.post(`${(environment as any).chat}/rooms`, payload);
  }
  message(userName: string) {
    this.createRoom({ type: 'private', members: [userName] }).subscribe({
      next: (res: any) => {
        console.log(res);
        this.toaster.success('chat room created successfully');
        this.router.navigate(['/chats'], {
          state: { id: res?.data?.id },
        });
      },
    });
  }
}
